import { Model } from 'dva'
import { TagsService } from '../../Service'
import { IsObject } from '../../Utils/helpers'
import { FailureHandler } from 'Utils/ApiHelper'
import { Tag } from './types'

const Tags: Model = {
  namespace: 'tags',
  state: {
    list: [],
  },
  effects: {
    *list(
      { useCache = true, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        let tags = yield select((state: any) => state.tags.list)
        if (!(tags.length > 0 && useCache)) {
          tags = yield call(TagsService.tagsList, {})
          yield put({ type: 'modifyList', payload: tags })
        }
        onSuccess(tags)
      } catch (err: any) {
        FailureHandler('Error fetching tags', err, onFailure)
      }
      setLoading(false)
    },
    *retrieve(
      { id, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        let tag = yield select((state: any) => state.tags.list.find((tag: Tag) => tag.id === id))
        if (!tag) {
          tag = yield call(TagsService.tagsRetrieve, { id: id })
        }
        yield put({ type: 'modifyList', payload: tag })
        onSuccess(tag)
      } catch (err) {
        FailureHandler('Could not find the tag!', err, onFailure)
      }
      setLoading(false)
    },
    *create(
      { data = {}, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put }
    ) {
      setLoading(true)
      try {
        const response = yield call(TagsService.tagsCreate, { requestBody: data })
        yield put({ type: 'modifyList', payload: response })
        onSuccess(response)
      } catch (err) {
        FailureHandler('Error adding a tag', err, onFailure)
      }
      setLoading(false)
    },
    *partialUpdate(
      { id, data, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put }
    ) {
      setLoading(true)
      try {
        const response = yield call(TagsService.tagsPartialUpdate, { id: id, requestBody: data })
        yield put({ type: 'modifyList', payload: response })
        onSuccess(response)
      } catch (err) {
        FailureHandler('Error editing a tag', err, onFailure)
      }
      setLoading(false)
    },
    *destroy(
      { id, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        yield call(TagsService.tagsDestroy, { id: id })
        yield put({ type: 'modifyList', payload: id })
        onSuccess()
      } catch (err) {
        FailureHandler('Error deleting a tag', err, onFailure)
      }
      setLoading(false)
    },
  },
  reducers: {
    modifyList(state, action) {
      // clone the list
      let list = [...state.list]
      if (IsObject(action.payload)) {
        // if the payload is an object, it's a single object, so add it to the list
        list = list.filter((l: Tag) => l.id !== action.payload.id)
        list.push(action.payload)
      } else if (Array.isArray(action.payload)) {
        // if the payload is an array, it's a list of objects, so add them to the list
        list = list
          .filter((l: Tag) => !action.payload.map((p: Tag) => p.id).includes(l.id))
          .concat(action.payload)
      } else if (Number.isInteger(action.payload)) {
        // if the payload is an integer, it's an id sent in delete operations, so remove it from the list
        list = list.filter((l: Tag) => l.id !== action.payload)
      }
      return {
        ...state,
        list: list,
      }
    },
    resetTags(state, action) {
      return {
        ...state,
        list: [],
      }
    },
  },
}

export default Tags
